import { Expose } from "class-transformer";
import type { UUID } from "crypto";
import type { ActivityTypeEnum } from "../../enums/activityType.enum";
import type { AtypicalContractTypeEnum } from "../../enums/atypicalContractType.enum";
import type { EmployeeContractTypeEnum } from "../../enums/employeeContractType.enum";
import type { EmploymentTypeEnum } from "../../enums/employmentType.enum";
import type { QuasiSubordinateContractTypeEnum } from "../../enums/quasiSubordinateContractType.enum";
import type { SelfEmploymentTypeEnum } from "../../enums/selfEmploymentType.enum";
import type { StudyLevelEnum } from "../../enums/studyLevel.enum";
import type { UnemploymentTypeEnum } from "../../enums/unemploymentType.enum";
import type { IActivityDto } from "./activity.dto.interface";

export class ActivityDto implements IActivityDto {
  @Expose()
  id?: UUID;

  @Expose()
  activityType!: ActivityTypeEnum;

  @Expose()
  isMainActivity: boolean = true;

  @Expose()
  atypicalContractType?: AtypicalContractTypeEnum | undefined;

  @Expose()
  employeeContractType?: EmployeeContractTypeEnum | undefined;

  @Expose()
  employerName?: string | undefined;

  @Expose()
  employerVATTaxCode?: string | undefined;

  @Expose()
  employmentType?: EmploymentTypeEnum | undefined;

  @Expose()
  selfEmploymentType?: SelfEmploymentTypeEnum | undefined;

  @Expose()
  studyLevel?: StudyLevelEnum | undefined;

  @Expose()
  unemploymentType?: UnemploymentTypeEnum | undefined;

  @Expose()
  soleProprietorshipRegistered?: boolean | undefined;

  @Expose()
  quasiSubordinateContractType?: QuasiSubordinateContractTypeEnum | undefined;
}
